import React, { useCallback, useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import useApi from "../Api/Api";
import Button from "../Components/Button";
import EditUser from "../Forms/EditUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import UsersLayout from "./UsersLayout";

const UserDetails = () => {
  const params = useParams();
  const api = useApi();
  const [showForm, setShowForm] = useState(false);
  const [user, setUser] = useState({
    email: "",
    first_name: "",
    last_name: "",
    administrator: "",
  });

  const handleShowForm = () => {
    setShowForm(!showForm);
  };

  const getUser = useCallback(() => {
    api.get(`/users/${params.userId}`).then((r) => {
      setUser(r.data);
    });
  }, [api, setUser, params.userId]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <UsersLayout>
      <div className="text-black bg-gray-100 pt-2 pb-8">
        {showForm && (
          <EditUser
            handleShowForm={handleShowForm}
            getUser={getUser}
          ></EditUser>
        )}
        <div className={showForm ? "blur" : ""}>
          <div className="mt-8 mx-8 py-9 px-12 text-black bg-white rounded-lg border">
            <Link to="/users">
              <div className="mt-1 font-medium text-black text-sm">
                <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to
                users list
              </div>
            </Link>
            <span className="flex justify-end text-sm -mt-5 -mb-7">
              {!showForm && (
                <Button
                  onClick={handleShowForm}
                  className="button"
                  text="Edit"
                ></Button>
              )}
            </span>
            <div
              className={
                showForm
                  ? "pt-11 text-2xl pb-7 font-medium"
                  : "py-2 mb-5 text-2xl font-medium"
              }
            >
              {user.first_name} {user.last_name}
            </div>
            <div className="text-black font-light text-sm border-b">
              <div>
                <div className="text-lg font-medium border-b">
                  <div className="pt-12 pb-5">User Details</div>
                </div>
                <div className="flex pt-8 pb-7 border-b">
                  <div className="w-1/2">Name</div>
                  <div className="w-1/5 font-semibold">
                    {user.first_name} {user.last_name}
                  </div>
                </div>
                <div className="py-6 text-lg font-medium border-b">
                  <div className="mt-5">Contact Info</div>
                </div>
                <div className="flex py-7 border-b">
                  <div className="w-1/2">Email</div>
                  <div className="w-1/5 font-semibold">{user.email}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UsersLayout>
  );
};

export default UserDetails;
